import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuInputsOption} from '@Components/contextual-menu/components/contextual-menu-inputs-option';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextItem} from '@Hooks/poster-editor/useGetKeyFromTextItem';

interface EditTextOptionProps {
  isInSidebar?: boolean;
}

export function EditTextOption({isInSidebar = false}: EditTextOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemText = useGetKeyFromTextItem('text');

  if (!activeItem || !activeItem.isText() || activeItemText === undefined) {
    return null;
  }

  const onInputChange = (val: string): void => {
    void activeItem.updateFromObject(
      {
        text: val,
      },
      {
        undoable: false,
      }
    );
  };

  const onInputChangeEnded = (val: string): void => {
    void activeItem.updateFromObject({
      text: val,
      textStyles: activeItem.textStyles.getLanguageScriptAndFontForText(val),
    });
  };

  return (
    <>
      {isInSidebar ? <ContextualMenuHeadingOption id="edit-text-heading" text={window.i18next.t('pmwjs_edit_mask_text')} /> : null}
      <ContextualMenuInputsOption
        id="edit-text-option"
        isMultiline
        maxNumberOfRows={isInSidebar ? 5 : 2}
        value={activeItemText}
        onInputChange={onInputChange}
        onInputChangeEnded={onInputChangeEnded}
        maxLength={10000}
        onInputFocus={(): void => {
          if (!isInSidebar) {
            activeItem.restoreDefaultState();
          }
        }}
      />
    </>
  );
}
